import { render, staticRenderFns } from "./BinUtility.vue?vue&type=template&id=4240c52b"
import script from "./BinUtility.vue?vue&type=script&lang=js"
export * from "./BinUtility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports